import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function OfferBlock() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="offer" ref={ref} className="w-full bg-teal-900 text-white py-20 md:py-28" data-id="element-131">
      <div className="max-w-5xl mx-auto px-6" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.7
      }} data-id="element-133">
          <div className="flex items-center justify-center gap-3 mb-12" data-id="element-134">
            <SparklesIcon className="w-8 h-8 text-amber-400" data-id="element-135" />
            <h2 className="text-3xl md:text-4xl font-bold text-center" data-id="element-136">
              Recupera el Control de Tu Mente Hoy Mismo
            </h2>
            <SparklesIcon className="w-8 h-8 text-amber-400" data-id="element-137" />
          </div>

          <div className="flex flex-col md:flex-row items-center gap-10 md:gap-14" data-id="element-138">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={isInView ? {
            opacity: 1,
            scale: 1
          } : {
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="flex-shrink-0 w-56 md:w-64" data-id="element-139">
              <img src="https://cdn.magicpatterns.com/uploads/fUdKLJEcbMVJ1YQZg6VvMp/menopausia.png" alt="Menopausia Sin Niebla — El Protocolo de 21 Días" className="w-full h-auto rounded-lg shadow-2xl shadow-black/30" data-id="element-140" />
            </motion.div>

            <div className="flex-1 text-center md:text-left" data-id="element-141">
              <p className="text-xl md:text-2xl mb-8 leading-relaxed" data-id="element-142">
                Accede al paquete completo de "Menopausia Sin Niebla: El
                Protocolo de 21 Días" por un pago único.
              </p>

              <div id="offer-price" className="bg-white/10 backdrop-blur-sm rounded-lg p-8 mb-8 inline-block" data-id="element-143">
                <div className="text-2xl text-white/60 line-through mb-1" data-id="element-144">
                  $27 USD
                </div>
                <div className="text-5xl md:text-6xl font-bold text-amber-400 mb-2" data-id="element-145">
                  $13.50 USD
                </div>
                <p className="text-lg text-white/90" data-id="element-146">
                  Pago único • Acceso inmediato
                </p>
                <span className="inline-block mt-3 bg-amber-600 text-white text-sm font-semibold px-4 py-1 rounded-full" data-id="element-147">
                  50% de descuento
                </span>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start items-center" data-id="element-148">
                <motion.a href="https://claramenteshop.com/cart/44325058838611:1" target="_blank" rel="noopener noreferrer" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-block bg-amber-600 hover:bg-amber-700 text-white font-bold px-12 py-5 rounded-lg text-xl transition-colors shadow-xl w-full sm:w-auto" data-id="element-149">
                  Haz Clic Aquí para Recuperar tu Claridad Mental
                </motion.a>
              </div>

              <p className="text-lg mt-6 text-white/90" data-id="element-150">
                Acceso inmediato tras la compra.
              </p>

              <motion.div initial={{
              opacity: 0
            }} animate={isInView ? {
              opacity: 1
            } : {
              opacity: 0
            }} transition={{
              duration: 0.7,
              delay: 0.3
            }} className="mt-6" data-id="element-151">
                <a href="#" className="inline-block bg-white/20 hover:bg-white/30 text-white font-semibold px-10 py-4 rounded-lg text-lg transition-colors" data-id="element-152">
                  Reclama tu Agudeza Mental Ahora
                </a>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}